import gsap from 'gsap';

class MidCalltoAction {
    constructor({ element }) {
        this.element = element;
    }

    init() {
        let background = this.element.querySelector( '.bg' );
        let text = this.element.querySelector( 'p' );
        let button = this.element.querySelector( '.btn' );

        this.animation = gsap.timeline({ paused: true });

        if( text ) {
            this.animation.fromTo( background, {
                opacity: 0,
                duration: 0.5,
                scale: 0.5
            }, {
                opacity: 1,
                scale: 1,
            } ).fromTo( text, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.3
            } ).fromTo( button, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.3
            } );
        } else {
            this.animation.fromTo( background, {
                opacity: 0,
                duration: 0.5,
                scale: 0.5
            }, {
                opacity: 1,
                scale: 1,
            } ).fromTo( button, {
                opacity: 0
            }, {
                opacity: 1,
                duration: 0.3
            } );
        }

        this.element.animation = this.animation;

        this.element.addEventListener( 'CallEvent', ( e ) => {
            this.animate();
        } );
    }

    animate() {
        this.animation.play();
    }
}

export default function () {
    document.querySelectorAll( '[data-scroll-call="mid-call-to-action"]' ).forEach( ( element ) => {
        let mcta = new MidCalltoAction( { element } );
        setTimeout( () => {
            mcta.init();
        }, 500 );
    } );
}